/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var format = require('../ol-ext/format');
var tileSource = _interopDefault(require('../mixin/tile-source'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var minilo = require('../util/minilo');

var VectorTileSource = __ol__.source.VectorTile;
var props = {
  cacheSize: {
    type: Number,
    default: 128
  },
  /**
   * Source format factory
   * @type {(function(): ol.format.Feature|undefined)} formatFactory
   */
  formatFactory: {
    type: Function,
    default: defaultFormatFactory
  },
  overlaps: {
    type: Boolean,
    default: true
  }
};

var methods = {
  /**
   * @return {ol.source.VectorTile}
   */
  createSource: function createSource() {
    return new VectorTileSource({
      attributions: this.attributions,
      cacheSize: this.cacheSize,
      format: this.formatFactory(),
      logo: this.logo,
      overlaps: this.overlaps,
      projection: this.projection,
      tileGrid: this._tileGrid,
      tileLoadFunction: this.tileLoadFunction,
      tileUrlFunction: this.createUrlFunc(),
      wrapX: this.wrapX,
      transition: this.transition
    });
  }
};

var Source = {
  name: 'vl-source-vector-tile',
  mixins: [tileSource],
  props: props,
  methods: methods

  /**
   * @return {ol.format.TopoJSON}
   */
};function defaultFormatFactory() {
  return format.createMvtFmt();
}

var index = {
  Source: Source,
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Source, options);

    Vue.component(Source.name, Source);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/vector-tile-source/index.js
// module id = 1497
// module chunks = 1